import script from "./LetterByLetter.vue?vue&type=script&lang=ts&setup=true"
export * from "./LetterByLetter.vue?vue&type=script&lang=ts&setup=true"

import "./LetterByLetter.vue?vue&type=style&index=0&id=076167b8&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-076167b8"]])

export default __exports__